import { MdCurrencyRupee } from "react-icons/md";
import { FaBagShopping } from "react-icons/fa6";
import { HiBanknotes } from "react-icons/hi2";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "react-tooltip";

const ReconFirstSection = ({ count, amount, penalty }) => {
  return (
    <div className="recon-left-section-new">
      <div className="recon-left-section-2">
        <div className="recon-new-section">
          <div className="recon-data-icon-box">
            <p className="recon-heading-new">Total Count</p>
            <IoMdInformationCircleOutline
              className="my-anchor-element1"
              style={{
                color: "#878a99",
              }}
            />

            <Tooltip
              anchorSelect=".my-anchor-element1"
              place="top"
              className="custom-reduce"
            >
              Total Number Of Charegeback
            </Tooltip>
          </div>
          <div className="recon-data-icon-box">
            <p className="recon-sub-heading-new">{Number(count).toFixed(2)}</p>
            <div className="recon-icon-div">
              <FaBagShopping
                style={{
                  width: "1rem",
                  height: "1rem",
                  color: "#ffffff",
                }}
              />
            </div>
          </div>
        </div>
        <div className="recon-new-section">
          <div className="recon-data-icon-box">
            <p className="recon-heading-new">Total Amount</p>
            <IoMdInformationCircleOutline
              className="my-anchor-element"
              style={{
                color: "#878a99",
              }}
            />

            <Tooltip
              anchorSelect=".my-anchor-element"
              place="top"
              className="custom-reduce"
            >
              Total Amount of Charegeback
            </Tooltip>
          </div>
          <div className="recon-data-icon-box">
            <p className="recon-sub-heading-new"> ₹{Number(amount).toFixed(2)} </p>
            <div className="recon-icon-div">
              <MdCurrencyRupee
                style={{
                  width: "1rem",
                  height: "1rem",
                  color: "#ffffff",
                }}
              />
            </div>
          </div>
        </div>

        <div className="recon-new-section">
          <div className="recon-data-icon-box">
            <p className="recon-heading-new">Penalty Amount</p>
            <IoMdInformationCircleOutline
              className="my-anchor-element2"
              style={{
                color: "#878a99",
              }}
            />

            <Tooltip
              anchorSelect=".my-anchor-element2"
              place="top"
              className="custom-reduce"
            >
              Penalty Amount of Charegeback
            </Tooltip>
          </div>
          <div className="recon-data-icon-box">
            <p className="recon-sub-heading-new"> ₹{Number(penalty).toFixed(2)} </p>
            <div className="icon-div">
              <HiBanknotes
                style={{
                  width: "1rem",
                  height: "1rem",
                  color: "#ffffff",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconFirstSection;
